import React from "react";

import { AppBottomSheet, AppBottomSheetProps } from "./Generic/AppBottomSheet";

interface Props extends AppBottomSheetProps {
  errorMessage: string | null;
}

const QuestionErrorBottomSheet = (props: Props) => {
  return (
    <AppBottomSheet {...props} rounded={true}>
      {props.errorMessage}
    </AppBottomSheet>
  );
};

export default React.memo(QuestionErrorBottomSheet);
